/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * modules.js
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
/**
 * Import module.
*/
import { setSmoothScroll } from "./setSmoothScroll";
import { setDrawerButton } from "./setDrawerButton";
import { setDataCounter } from "./setDataCounter";
import { setScrollTrigger } from "./setScrollTrigger";
import { setSwiper } from "./setSwiper";

function addModule() {
  const html = document.documentElement;
  const header = document.querySelector('.header');
  const footer = document.querySelector('.footer');
  const toTopBtn = document.getElementById('toTopBtn');
  const fixButton = document.querySelector('.fixButton');
  const fixButtonEl = document.querySelectorAll('.fixButton-el');
  const fixButtonElButton = document.querySelectorAll('.fixButton-el__button');
  const flagMv = document.querySelector('.--js-flagMv');
  const negativeMarginBottom = document.querySelector('.--js-negative-margin-bottom');

  /**
   * @name setScrollPaddingTop
   * @description アンカーリンク先に”scroll-padding-top”を設定する
   * @param {Number} headerHeight ヘッダーの高さ
   */
  function setScrollPaddingTop() {
    const init = () => {
      let headerHeight = header.clientHeight;
      html.style.scrollPaddingTop = `${headerHeight}px`;
    }
    init();
    window.addEventListener("resize", init);
  }

  /**
   * @name scrollFlagMv
   * @description 画面上部からのスクロール量を取得し、MVが画面上部に到達後にtrueを返す
   */
  const scrollFlagMv = () => {
    let flagMvTop = flagMv.getBoundingClientRect().top + window.pageYOffset + 1;
    let scrollTop = window.pageYOffset;
    return scrollTop >= flagMvTop ? true : false;
  }

  /**
   * @name scrollFlagFooter
   * @description スクロール時にfooterから指定した距離までスクロールしたらtrueを返す
   * @param {Number} documentHeight ドキュメントの高さ
   * @param {Number} windwHeight ウィンドウの高さ
   * @param {Number} footerHeight フッターの高さ
   */
  const scrollFlagFooter = () => {
    let documentHeight = document.body.clientHeight;
    let windwHeight = window.innerHeight;
    let footerHeight = footer.clientHeight;
    let toTopBtnRect = toTopBtn.getBoundingClientRect();
    let toTopBtnParametor = toTopBtnRect.height + toTopBtnRect.height / 2;
    let toTopPosition = window.innerWidth >= 835 ? toTopBtnParametor + 30 : toTopBtnParametor / 2 + 10;
    return window.pageYOffset > documentHeight - windwHeight - footerHeight + toTopPosition ? true : window.pageYOffset < footerHeight ? false : null;
  }

  /**
   * @name scrollFlagFixButton
   * @description 画面上部からのスクロール量を取得し、fixButtonの高さ分スクロールしたらtrueを返す
   */
  const scrollFlagFixButton = () => {
    let fixButtonHeight = fixButton.getBoundingClientRect().height;
    let scrollTop = window.pageYOffset;
    fixButtonEl.forEach(el => {
      scrollTop >= fixButtonHeight && fixButtonToggleClass(el, '--active', "close");
      scrollTop === 0 && fixButtonToggleClass(fixButtonEl[0], '--active', "close");
      scrollTop === 0 && fixButtonToggleClass(fixButtonEl[1], '--active', "open");
    });
  }

  /**
   * @name setNegativeMarginBottom
   * @description ".--js-negativeMarginBottom"にマイナスマージンを設定する
   */
  const setNegativeMarginBottom = () => {
    if (!negativeMarginBottom) return;
    let fixButtonHeight = fixButton.clientHeight;
    negativeMarginBottom.style = `--negative-margin-bottom: ${fixButtonHeight}px`;
  }

  /**
   * @name fixButtonToggleClass
   * @description クラスの付け替え
   */
  const fixButtonToggleClass = (el, className, action = "toggle" | "open" | "close") => {
    let actionList = ["toggle", "open", "close"];
    let open = () => el.classList.add(className);
    let close = () => el.classList.remove(className);
    let toggle = () => el.classList.contains(className) ? close() : open();
    actionList.includes(action) && eval(action)();
  }

  /**
   * @name fixButtonToggle
   * @description 固定ボタンの開閉
   */
  const fixButtonToggle = () => {
    fixButtonElButton.forEach(button => {
      button.addEventListener('click', (el) => {
        fixButtonElButton.forEach(button => button !== el.currentTarget && fixButtonToggleClass(button.parentNode, '--active', "close"));
        fixButtonToggleClass(el.currentTarget.parentNode, '--active', "toggle")
      });
    });
  }

  /**
   * @name transform
   * @description 呼び出した関数を実行する
   */
  const transform = () => {
    scrollFlagFooter() ? html.classList.add('--totop-fixed') : html.classList.remove('--totop-fixed');
    scrollFlagFooter() ? fixButtonEl[1].classList.add('--stop') : fixButtonEl[1].classList.remove('--stop');
    scrollFlagMv() ? toTopBtn.dataset.state = "show" : toTopBtn.dataset.state = "";
    scrollFlagFixButton();
  }

  window.addEventListener("scroll", transform);
  scrollFlagMv();
  scrollFlagFooter();
  setScrollPaddingTop();
  fixButtonToggle();
  setNegativeMarginBottom();
}

/**
 * Do modules.
 */
export function modules() {
  setSmoothScroll();
  setDrawerButton();
  setDataCounter();
  setScrollTrigger();
  setSwiper();
  addModule();
}